import {JavascriptComponent} from "./javascript.component";
import {RouterModule, Routes} from "@angular/router";
import {NgModule} from "@angular/core";

const routes: Routes = [
  { path: 'javascript', component: JavascriptComponent }
];

@NgModule ({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})

export class JavascriptRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/javascript/javascript-routing.module.ts